<div class="row" [ngClass]="{ first: first() }">
  <div class="row-nb">{{ number() }}</div>
  <div class="row-content">
    <div class="row-title">{{ title() }}</div>
    <div class="row-description">{{ description() }}</div>
  </div>
</div>